import { createSelector } from 'reselect';

const selectUser = (state) => state.users;

export const selectCurrentUser = createSelector(
  [selectUser],
  (users) => users.currentUser
);

export const selectIsFlexisafUser = createSelector(
  [selectCurrentUser],
  (currentUser) => {
    const email = currentUser?.user?.email;
    return (
      email === 'safapplyadmin' || email?.includes('@flexisaf.com') || false
    );
  }
);

export const selectRefreshToken = createSelector(
  [selectUser],
  (users) => users?.refresh_token
);

export const selectIsLoading = createSelector(
  [selectUser],
  (users) => users.isLoading
);

export const selectError = createSelector([selectUser], (users) => users.error);
 